import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  ResponsiveContainer,
} from "recharts";

interface CoverageRadarProps {
  categoryPercentages: Record<string, number>;
}

export function CoverageRadar({ categoryPercentages }: CoverageRadarProps) {
  const data = Object.entries(categoryPercentages).map(([name, value]) => ({
    category: name.length > 20 ? name.slice(0, 18) + "..." : name,
    fullName: name,
    coverage: Math.round(value),
  }));

  if (data.length < 3) {
    // Radar chart needs at least 3 data points
    return (
      <div className="space-y-2">
        <h3 className="text-sm font-medium">Coverage by Category</h3>
        <div className="space-y-1">
          {data.map((d) => (
            <div key={d.fullName} className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">{d.fullName}</span>
              <span className="font-medium">{d.coverage}%</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      <h3 className="mb-2 text-sm font-medium">Coverage by Category</h3>
      <ResponsiveContainer width="100%" height={300}>
        <RadarChart data={data}>
          <PolarGrid stroke="#334155" />
          <PolarAngleAxis
            dataKey="category"
            tick={{ fontSize: 10, fill: "#94a3b8" }}
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, 100]}
            tick={{ fontSize: 10, fill: "#64748b" }}
          />
          <Radar
            name="Coverage"
            dataKey="coverage"
            stroke="#3b82f6"
            fill="#3b82f6"
            fillOpacity={0.2}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
